<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
          <el-form-item label="我方账号名称" prop="myAccountTitle">
          <el-input v-model="dataForm.myAccountTitle" placeholder="我方账号名称"></el-input>
      </el-form-item>
          <el-form-item label="我方银行账号" prop="myBankAccount">
          <el-input v-model="dataForm.myBankAccount" placeholder="我方银行账号"></el-input>
      </el-form-item>
        <el-form-item label="业务日期">
            <el-date-picker v-model="dataForm.businessDate" type="datetime" placeholder="业务日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                            style="width:100%" >
            </el-date-picker>
        </el-form-item>
          <el-form-item label="摘要" prop="summary">
          <el-input v-model="dataForm.summary" placeholder="摘要"></el-input>
      </el-form-item>
          <el-form-item label="业务类型" prop="businessType">
          <el-input v-model="dataForm.businessType" placeholder="业务类型"></el-input>
      </el-form-item>
          <el-form-item label="对方账号名称" prop="theirAccountTitle">
          <el-input v-model="dataForm.theirAccountTitle" placeholder="对方账号名称"></el-input>
      </el-form-item>
          <el-form-item label="对方银行账号" prop="theirBankAccount">
          <el-input v-model="dataForm.theirBankAccount" placeholder="对方银行账号"></el-input>
      </el-form-item>
          <el-form-item label="收入金额" prop="incomeAmount">
          <el-input v-model="dataForm.incomeAmount" placeholder="收入金额"></el-input>
      </el-form-item>
          <el-form-item label="支出金额" prop="expenditureAmount">
          <el-input v-model="dataForm.expenditureAmount" placeholder="支出金额"></el-input>
      </el-form-item>
          <el-form-item label="流水号" prop="serialNumber">
          <el-input v-model="dataForm.serialNumber" placeholder="流水号"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        myAccountTitle: '',
        myBankAccount: '',
        businessDate: '',
        summary: '',
        businessType: '',
        theirAccountTitle: '',
        theirBankAccount: '',
        incomeAmount: '',
        expenditureAmount: '',
        serialNumber: '',
        creator: '',
        createDate: '',
        updater: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        myAccountTitle: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        myBankAccount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businessDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        summary: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        businessType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        theirAccountTitle: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        theirBankAccount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        expenditureAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        serialNumber: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        creator: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updater: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/plattransactiondetais/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/plattransactiondetais/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
